import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import React from 'react';
import zeplinColor from 'theme/Color';
import style from './NewClientType.module.css';

const NewClientType = ({
  modalOpen,
  handleModalClose,
  handleContinueAdd,
  setTypeSelected,
  typeSelected,
  setAnchorEl,
  sf_token,
}: {
  modalOpen: boolean;
  handleModalClose: () => void;
  handleContinueAdd: () => void;
  setTypeSelected: React.Dispatch<React.SetStateAction<string>>;
  typeSelected: string;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  sf_token: string;
}) => {
  const handleType = (item: any) => {
    setTypeSelected(item.target.value);
  };
  const clientType = ['Talent', 'Athlete', 'Business Development'];
  return (
    <CustomModal handleClose={() => {}} open={modalOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '16px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: { xs: '300px', xl: '339px' },
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '14px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Create Client
                </Typography>
              </Box>
              <img
                src={'/assets/cross.svg'}
                alt='logo'
                className={style.icon}
                onClick={handleModalClose}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <RadioGroup
                  aria-labelledby='demo-controlled-radio-buttons-group'
                  name='controlled-radio-buttons-group'
                  value={typeSelected}
                  onChange={handleType}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                    padding: '0px',
                  }}
                >
                  {clientType.map((name) => (
                    <FormControlLabel
                      value={name}
                      control={
                        <Radio
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                      }
                      label={name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '& .MuiFormControlLabel-label': {
                          fontSize: { xs: '14px', xl: '16px' },
                        },
                        '& .MuiButtonBase-root': {
                          fontSize: { xs: '14px', xl: '16px' },
                          color: zeplinColor.BasicBlack,
                        },
                        padding: '0px',
                      }}
                    />
                  ))}
                </RadioGroup>
              </Box>
            </Box>
            <CustomButton
              disabled={clientType[0] ? false : true}
              onClick={handleContinueAdd}
              variant='contained'
              color={'primary'}
              style={{
                width: '100%',
                borderRadius: '14px',
                height: 48,
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1, fontSize: { xs: '14px', xl: '16px' } }}
              text={'Continue'}
            />
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default NewClientType;
